import { AfterViewInit, Component, ElementRef, Input, Output, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import * as CryptoJS from 'crypto-js';

import { PasswordRoutingModule } from './password.routing.module';

declare let $: any;
const errorMessage: any = {
  required: 'Ce champ est requis'
};

@Component({
  selector: 'password',
  template: `
  <div class="md-form form-sm" [formGroup]="form">  
    <i *ngIf="glyph" class="{{glyph}} prefix"></i>
    <!--<input id="{{name}}" type="text" [disabled]="!enabled"  [(ngModel)]=value (ngModelChange)="valueChange.emit($event)"> 
    <label class="active" for="name">{{caption}}</label>-->
    <input [hidden]="true" type="text" id="{{name}}" class="form-control" formControlName="{{name}}">
    <input type="password" id="{{name}}" class="form-control" [attr.length]="length" [ngClass]="{'invalid':error}" value="{{value}}" (change)="setPasswordEncrypted($event)" #password> 
    <label for="{{name}}" [ngClass]="{'active':control.value}"><em *ngIf="readonly">{{caption}}</em><b *ngIf="!readonly">{{caption}}</b> <span *ngIf="required" style="color: red;"><b>*</b></span></label> 
    <div *ngIf="error" class="alert alert-danger">
      {{ error }}
    </div> 
    <!-- [attr.for] -->
  </div>`
})

export class PasswordComponent implements OnInit {
  public SECRET_KEY: string = 'secret key 123';
  @Input() public name: string = '';
  @Input() public length: string = '0';
  @Input() public caption: string = '';
  @Input() public placeholder: string = '';
  public readonly: boolean = false;
  @Input() public control: AbstractControl;
  @Input() public enabled: Boolean = false;
  @Input() public value: string = '';
  @Input() public glyph: string = 'fa fa-expeditedssl';
  @Output() public valueChange = new EventEmitter<string>();
  @Input() public form: FormGroup;
  @Input() public error: any;
  @Input() public required: boolean = false;
  @Input() public displayCharacterCounter: boolean = true;
  @ViewChild('password') password: ElementRef;
  public elementRef: ElementRef;
  @Input() public visible: boolean = true;

  constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  ngOnInit(): void {
    this.placeholder = this.caption;
    this.value = this.getPasswordEncrypted();
    if (!this.control) {
      if (this.form.controls[this.name] == null) {
        this.control = new FormControl();
        this.form.addControl(this.name, this.control);
      }
      this.control = this.form.controls[this.name];
    }
    if (this.required) {
      this.control.setValidators(Validators.required);
    }
    this.control.valueChanges.subscribe((value) => {
      //console.log(value)
      this.returnError();
    });
  }

  ngAfterViewInit() {
    if ((this.length != '0') && (this.displayCharacterCounter)) {
      $(this.password.nativeElement).characterCounter();
    }
  }

  public getPasswordEncrypted(): string {
    let plaintext = '';
    if (this.form.controls[this.name].value != null) {
      let bytes = CryptoJS.AES.decrypt(this.form.controls[this.name].value, this.SECRET_KEY);
      plaintext = bytes.toString(CryptoJS.enc.Utf8);
    }
    console.log('get');
    console.log(this.form.controls[this.name].value);
    console.log(plaintext);
    return plaintext;
  }

  public setPasswordEncrypted($event: any): void {
    this.value = $(this.password.nativeElement)[0].value;
    let ciphertext = CryptoJS.AES.encrypt(this.value, this.SECRET_KEY);
    this.form.controls[this.name].patchValue(ciphertext.toString());
    console.log('set');
    console.log('1'+ this.value + '2');
    console.log(ciphertext.toString());
  }

  returnError() {
    this.error = '';
    if (this.control && !this.control.valid && this.control.errors) {
      for (const key in this.control.errors) {
        if (key in errorMessage) {
          this.error += errorMessage[key] + ' ';
        }
      }
    }
  }

}
